"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.error.profession_required': 'Si prega di selezionare una professione prima di procedere',
    'onboarding.error.profession_select_first': 'Si prega di selezionare prima una professione',
    'onboarding.error.avatar_name_required': 'Il nome dell\'avatar è richiesto',
    'onboarding.error.avatar_name_provide': 'Si prega di fornire un nome per l\'avatar',
    'onboarding.error.answer_required': 'La risposta è richiesta',
    'onboarding.error.complete_required_step': 'Si prega di completare il passaggio richiesto',
    'onboarding.error.complete_step': 'Si prega di completare il passaggio',
    'onboarding.error.before_finishing': 'prima di finire',
    'onboarding.error.professions_load_failed': 'Errore nel caricamento delle professioni',
    'onboarding.error.professions_load_general': 'Errore generale nel caricamento delle professioni',
    'onboarding.error.steps_load_failed': 'Errore nel caricamento dei passaggi',
    'onboarding.error.steps_load_general': 'Errore generale nel caricamento dei passaggi',
    'onboarding.error.questions_load_failed': 'Errore nel caricamento delle domande',
    'onboarding.error.questions_load_general': 'Errore generale nel caricamento delle domande',
    'onboarding.error.load_failed': 'Errore nel caricamento dei dati di onboarding',
    'onboarding.error.load_general': 'Errore generale nel caricamento dell\'onboarding',
    'onboarding.error.save_failed': 'Errore nel salvataggio dell\'onboarding',
    'onboarding.error.save_general': 'Errore generale nel salvataggio dell\'onboarding',
};
